//# sourceMappingURL=polyline.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/vector/polyline.interface.js
// module id = 1197
// module chunks = 4